import { Injectable, inject } from '@angular/core';

import { ThemeConfigService } from '@core/theme/theme-config.service';

import type { HandelMembershipPageContent } from '../../theme.types';
import { MembresiasContentSource } from './membresias-content.source';
import { CLAVE_POR_VARIANTE, type MembresiasVariante } from './membresias-variante';

@Injectable({ providedIn: 'root' })
export class StaticMembresiasContentSource extends MembresiasContentSource {
  private readonly theme = inject(ThemeConfigService);

  load(variante: MembresiasVariante): Promise<HandelMembershipPageContent> {
    return Promise.resolve(this.theme.config().membershipPageContent[CLAVE_POR_VARIANTE[variante]]);
  }
}
